import { render, staticRenderFns } from "./Minisite.vue?vue&type=template&id=701fe14e&"
import script from "./Minisite.vue?vue&type=script&lang=js&"
export * from "./Minisite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701fe14e')) {
      api.createRecord('701fe14e', component.options)
    } else {
      api.reload('701fe14e', component.options)
    }
    module.hot.accept("./Minisite.vue?vue&type=template&id=701fe14e&", function () {
      api.rerender('701fe14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Minisite.vue"
export default component.exports